<iframe
    #iframe
    class="neuroglancer"
    src="neuroglancer/index.html"
    title="neuroglancer"
    autofocus
    [class.initialized]="initialized"
>
</iframe>
